import styles from './styles.module.scss';
import Button from '@/ui-kit/Button';
import SubmitButton from '@/ui-kit/SubmitButton';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import BaseModal from '@/modal/baseModal';
import { signOutScope } from '@/utils/session';
import { useAppDispatch } from '@/app/hooks';
import { logoutUser } from '@/features/user/userSlice';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router';

interface Props {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  timeEnded?: boolean;
}

export const AutologoutPanel = ({ isOpen, setIsOpen, timeEnded }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    Cookies.get('accessToken') &&
      signOutScope()
        .then((_resp: any) => navigate('log-in'))
        .catch(err => {
          console.log(err.data.message);
        });
  };

  const logoutModal = () => {
    handleLogout();
    return (
      <>
        {isOpen && (
          <BaseModal onClose={() => dispatch(logoutUser())} width='480px' mainStyle={'!z-[1002]'} modalStyle={'!z-[1003]'}>
            <div className={styles.modal_header}>
              <div className='flex'>
                <h6 className='text-xl'>{t('autologout.sessionEnded')}</h6>
              </div>
              <p className='body2 whitespace-pre-wrap'>{t('autologout.description2')}</p>
            </div>

            <div className={styles.modal_actions}>
              <SubmitButton
                label={t('autologout.logIn')}
                inputStyle={clsx(styles.modal_actions_submitButton, 'w-max button1 mr-0 ml-auto')}
                onClick={() => dispatch(logoutUser())}
                id='logoutButton'
              />
            </div>
          </BaseModal>
        )}
      </>
    );
  };

  const logoutWarningModal = () => {
    return (
      <>
        {isOpen && (
          <BaseModal onClose={() => setIsOpen(!isOpen)} width='480px' mainStyle={'!z-[1002]'} modalStyle={'!z-[1003]'}>
            <div className={styles.modal_header}>
              <div className='flex'>
                <h6 className='text-xl'>{t('autologout.youAreHere')}</h6>
              </div>
              <p className={'body2 whitespace-pre-wrap'}>{t('autologout.description')}</p>
            </div>

            <div className={styles.modal_actions}>
              <Button
                id='logoutButton'
                label={t('autologout.logOut')}
                inputStyle={clsx(styles.modal_actions_cancelButton, 'button1')}
                onClick={() => {
                  handleLogout();
                  dispatch(logoutUser());
                }}
              />
              <SubmitButton
                label={t('autologout.continue')}
                inputStyle='button1 w-max'
                onClick={() => setIsOpen(!isOpen)}
                id='continueButton'
              />
            </div>
          </BaseModal>
        )}
      </>
    );
  };

  return <div className={styles.container}>{timeEnded ? logoutModal() : logoutWarningModal()}</div>;
};
